import { DateTime } from "luxon";

import { demo_form } from "../forms";

export const demo_asset_landing = {
  _id: "demo-asset-1234",
  share_code: "DEMO1234",
  title: "EX149",
  subtitle: "Cat 349D2 L, 49t Excavator",
  banner: {
    key: "cat-349d2-l-49t-excavator.jpeg",
    extension: "jpeg",
    name: "cat-349d2-l-49t-excavator.jpeg",
    mime: "image/jpeg"
  },
  last_inspection_date: DateTime.local()
    .minus({ days: 1 })
    .toISO(),
  inspection_prestart_form: demo_form
};

export const demo_asset_landings = [demo_asset_landing];
